import SectionHeader from "../SectionHeader";
import img1 from "../../assets/home/featured-products/img01.png";
import img2 from "../../assets/home/featured-products/img02.png";
import img3 from "../../assets/home/featured-products/img03.png";
import img4 from "../../assets/home/featured-products/img04.png";
import { BsHeart, BsZoomIn } from "react-icons/bs";
import { CiShoppingCart } from "react-icons/ci";
import { Slide } from "react-slideshow-image";
import Button from "../Button";
import { useNavigate } from "react-router-dom";

export default function FeaturedProductsSection() {
  return (
    <>
      <SectionHeader>Featured Products</SectionHeader>
      {/* card */}
      <Slide
        duration={3000}
        transitionDuration={300}
        autoplay={false}
        arrows={false}
        indicators={() => (
          <div className="featured-indicator transition-all"></div>
        )}
      >
        <div className="flex justify-center py-5">
          <div className="flex mx-auto">
            <Card id={"1b2nel6"} img={img1} />
            <Card id={"1f43r26"} img={img2} />
            <Card id={"b2njf87"} img={img3} />
            <Card id={"kj5235f"} img={img4} />
          </div>
        </div>
        <div className="flex justify-center py-5">
          <div className="flex mx-auto">
            <Card id={"1b2r79d"} img={img1} />
            <Card id={"m454302"} img={img2} />
            <Card id={"nv79s3n"} img={img3} />
            <Card id={"nmfdg98"} img={img4} />
          </div>
        </div>
        <div className="flex justify-center py-5">
          <div className="flex mx-auto">
            <Card id={"md097fj"} img={img1} />
            <Card id={"08dsfvo"} img={img2} />
            <Card id={"0fsdf3j"} img={img3} />
            <Card id={"5n4kjsf"} img={img4} />
          </div>
        </div>
      </Slide>
    </>
  );
}

function Card({ img, id }) {
  const navigate = useNavigate();

  return (
    <div className="group transition-all text-center shadow-lg w-60 font-fontTwo mx-3">
      {/* image container */}
      <div className=" bg-[#F6F7FB] h-60 p-10 pb-4 relative">
        {/* on hover icons */}
        <div className=" transition-all hidden absolute top-0 left-0 bottom-0 right-0 group-hover:flex flex-col justify-between">
          {/* top part */}
          <div className=" flex mt-2 ml-2 items-center">
            <div className=" transition-all text-[#1389FF] hover:bg-bg_shade hover:text-[#2F1AC4] p-2 rounded-full ">
              <CiShoppingCart className="-translate-y-[2px]" size={20} />
            </div>
            <div className="  transition-all text-[#1389FF] hover:bg-bg_shade hover:text-[#2F1AC4] p-2 rounded-full">
              <BsHeart size={15} />
            </div>
            <div className="  transition-all text-[#1389FF] hover:bg-bg_shade hover:text-[#2F1AC4] p-2 rounded-full">
              <BsZoomIn size={15} />
            </div>
          </div>
          {/* bottom part */}
          <div className="mb-4">
            <Button
              color="green"
              onClick={() => navigate(`product/${id}`, { state: { img: img } })}
            >
              View Details
            </Button>
            {/* <button className="  bg-green rounded-sm text-white py-2 px-4"></button> */}
          </div>
        </div>
        {/* image */}
        <img src={img} alt="" />
      </div>
      {/* text container */}
      <div className=" p-3 group-hover:bg-text group-hover:text-white transition-all">
        <h4 className=" text-pink group-hover:text-white text-lg font-semibold mb-1">
          Cantilever chair
        </h4>
        {/* colors */}
        <div className="flex justify-center ">
          <div className=" h-1 bg-[#05E6B7] rounded-lg w-4"></div>
          <div className=" h-1 bg-pink rounded-lg w-4 mx-1"></div>
          <div className=" h-1 bg-text rounded-lg w-4"></div>
        </div>
        <p className=" my-1">Code Y523201</p>
        <p>$42.00</p>
      </div>
    </div>
  );
}
